module.exports = __webpack_public_path__ + "static/media/beepbeep.5207b7be.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/beepbeep.mp3
// module id = 183
// module chunks = 0